import axios from 'axios';
import { default401 } from './auth';
import { store } from '../store';

export const getUploadHistory = (page, step = undefined) => {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/batchupdate/`,
    headers: { Authorization: `Token ${token}` },
    params: { page, step },
  }).catch(default401);
};

export const getResultsHistory = () => {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/batchupdate/`,
    headers: { Authorization: `Token ${token}` },
  }).catch(default401);
};

export const getFileDownloadLink = (id) => {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/batchupdate/${id}/`,
    headers: { Authorization: `Token ${token}` },
    responseType: 'blob',
  }).catch(default401);
};
